import { Skeleton } from '@/components/ui/skeleton';
import type { Setup, SetupSearch } from './useSetup';

export interface StepProps {
  setup: Setup;
  index: number;
  /** Moves the page to another project/app (`?project=&app=`). */
  onSelect: (next: SetupSearch) => void;
}

/** Real geometry while a step's list loads: two table rows. */
export function RowsSkeleton({ rows = 2 }: { rows?: number }) {
  return (
    <div className="flex flex-col gap-2 rounded-lg border p-3" aria-busy="true" aria-label="Loading">
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className="flex items-center gap-3">
          <Skeleton className="h-4 w-1/3" />
          <Skeleton className="h-4 w-1/4" />
          <Skeleton className="ml-auto h-4 w-16" />
        </div>
      ))}
    </div>
  );
}
